
import { Cart } from '@/models/cart/cart'
import { CartItem } from '@/models/cart/cart-item'
import { Command, CommandResult, DealWithItemViaCartSpec } from '@/models/cart/specification/deal-with-item-via-cart'

export class DefaultDealWithItemViaCartSpec implements DealWithItemViaCartSpec {
  apply(command: Command): Command {
    return async (target: CartItem, cart: Cart): Promise<CommandResult> => {
      return command(target, cart)
    }
  }
}
